module.exports = __webpack_public_path__ + "img/grey-tape.5900359a.png";